import { Panel } from '../ledger';
import { providerLabel } from './homeCardModel';

// A league found on your provider account but not added yet. Adding keeps the
// existing join flow; its sync progress shows inside this card.
export function HomeAddLeagueCard({ league, syncing, progress, onAdd, disabled, label = '' }) {
  const meta = [providerLabel(league.provider), league.season ? `${league.season} season` : null].filter(Boolean).join(' · ');
  return (
    <Panel className="home-card" title={league.name} meta={meta} bodyClassName="ledger-panel-body" data-home-add={league.league_id}>
      <p>{league.num_teams ? `${league.num_teams} teams · not added yet` : 'Not added yet'}</p>
      {syncing ? (
        <>
          <div role="progressbar" aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100} aria-label={label || 'Syncing'}>
            <div className="home-progress"><div style={{ transform: `scaleX(${progress / 100})` }} /></div>
          </div>
          {label && <p className="ledger-state" aria-live="polite">{label}</p>}
        </>
      ) : (
        <button type="button" className="ledger-btn home-open" onClick={onAdd} disabled={disabled}>Add</button>
      )}
    </Panel>
  );
}

export default HomeAddLeagueCard;
